import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var RedoSVG = function RedoSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27,2a1,1,0,0,0-1,1v8.272L19.36,4.636A9,9,0,0,0,6.632,17.364L18.975,29.707a1,1,0,1,0,1.414-1.414L8.046,15.95a7,7,0,0,1,9.9-9.9L24.9,13H16a1,1,0,0,0,0,2H26.5A1.5,1.5,0,0,0,28,13.5V3A1,1,0,0,0,27,2Z"
  }));
};
RedoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(RedoSVG);